import  { h, Component, RenderableProps } from 'preact';
import { applySelectionToPattern } from '../lib/patternhelper';

interface ClueState { 
    lastAnimation: ClueAnimation
    animation: ClueAnimation
    displayWord: string
    displaySelected: string
}

export enum ClueAnimation { 
    CorrectWord,
    WrongWord,
    BonusWord,
    NextWord,
    PrevWord,
    None
 }

interface ClueProps { 
    word: string, 
    selectedLetters: string[],
    currentAnimation: ClueAnimation,
    onChangeClue?: (delta: number) => void
}

export class Clue extends Component<ClueProps,ClueState> {

    constructor(props: ClueProps) {
        super(props)
        this.state = {
            lastAnimation: ClueAnimation.None,
            animation: props.currentAnimation,
            displayWord: this.props.word,
            displaySelected: this.props.selectedLetters.join("")
        }
    }

    static getDerivedStateFromProps(nextProps: ClueProps, prevState: ClueState) {
        var state:Partial<ClueState> = null
        if (nextProps.currentAnimation != prevState.animation) {
              state = {
                    animation: nextProps.currentAnimation,
                    lastAnimation: prevState.animation
              }
        }

        //capure the current displayed word when the animation changes (unless the animation is None in which case let the selection change stuff)
       
        if (nextProps.currentAnimation == ClueAnimation.None && (prevState.displayWord != nextProps.word || prevState.displaySelected != nextProps.selectedLetters.join(""))) {
            state = state || {};
            state.displayWord = nextProps.word;
            state.displaySelected = nextProps.selectedLetters.join("");
        }

        return state;
    }

    onBack = () => {
        if (this.props.onChangeClue)
            this.props.onChangeClue(-1);
    }

    onForward = () => {
        if (this.props.onChangeClue)
            this.props.onChangeClue(1);
    }

    render( props: ClueProps, {lastAnimation, animation, displayWord, displaySelected}: ClueState)  {
        
        var animationClass;

        if (animation == ClueAnimation.CorrectWord) animationClass = "correct-word"
        if (animation == ClueAnimation.WrongWord) animationClass = "wrong-word"
        if (animation == ClueAnimation.BonusWord) animationClass = "bonus-word"
        if (animation == ClueAnimation.NextWord) animationClass = "next-word"
        if (animation == ClueAnimation.PrevWord) animationClass = "prev-word"
        if (animation == ClueAnimation.None) 
            if (lastAnimation == ClueAnimation.CorrectWord ||
                lastAnimation == ClueAnimation.NextWord )
                animationClass = "new-pattern"
            else if (lastAnimation == ClueAnimation.PrevWord)
                animationClass = "new-pattern-left"
            else
                animationClass = ""    
        
        let navStyle = {visibility: this.props.onChangeClue ? "visible": "hidden"}

        let outWord = applySelectionToPattern(displaySelected, displayWord);
        if (!outWord) {
            outWord = displayWord;
        }

        let outWordNoHints = applySelectionToPattern(displaySelected, displayWord.replace(/[^aeiou]/g, ' '));

        let letters =  outWord.split("").map(( l,idx) => (
            <span class={ (l != " " && outWordNoHints[idx] == " ") ? "letter-hint": ""} >{l == " " ? "\u2022": l}</span>
        ))

        return (
            <div class="clue-wrapper">
       
            <a class="clue-prev-button" style={ navStyle }   onClick={this.onBack}>&#8249;</a>
             
            <div class={"word-hint " + animationClass}>
            {  letters }
            </div>
            <a class="clue-next-button" style={ navStyle }  onClick={this.onForward}>&#8250;</a>
            
            </div>
        )
    }


}